import React from 'react';

interface CardComponentProps {
  title: string;
  children: React.ReactNode;
  className?: string;
}

const CardComponent: React.FC<CardComponentProps> = ({ title, children, className = '' }) => {
  return (
    <div className={`card ${className}`}>
      <h2 className="text-xl font-semibold mb-4">{title}</h2>
      {children}
    </div>
  );
};

export default CardComponent;
